import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { withCallState } from '@shared/store-features/call-state-feature.ts';
import { MediaLibraryState } from './media-library.model.ts';
import { foldersSlice } from '@store/media-library-store/folders.slice.ts';
import { mediaSlice } from '@store/media-library-store/media.slice.ts';
import { uploadFileSlice } from '@store/media-library-store/upload-file.slice.ts';
import { callStateStatusSlice } from '@store/media-library-store/call-state-status.slice.ts';
import { moveTreeSlice } from '@store/media-library-store/move-tree.slice.ts';
import { querySlice } from '@store/media-library-store/query.slice.ts';

const useMediaLibraryStore = create<MediaLibraryState>()(
  devtools(
    (set, get) => ({
      ...querySlice(set, get),
      ...foldersSlice(set, get),
      ...mediaSlice(set, get),
      ...moveTreeSlice(set, get),
      ...uploadFileSlice(set, get),
      ...callStateStatusSlice(set, get),
      ...withCallState(get)
    }),
    { name: 'MediaLibraryStore' }
  )
);

export default useMediaLibraryStore;
